import { InputItem, List, Modal, Radio, SearchBar, Toast } from "antd-mobile";
import { RightOutline } from "antd-mobile-icons";
import { Popup } from "antd-mobile-v5";
import React, {
  CSSProperties,
  forwardRef,
  useCallback,
  useEffect,
  useMemo,
  useRef,
  useState,
} from "react";
import { useUpdateEffect } from "react-use";
import axios from "../../util/axios";
import { UnicodeToAscii } from "../../util/unicodeToAscii";

interface SelectItemProps {
  dictionary: string;
  value: any;
  onChange: (value: any) => void;
  disabled?: boolean;
  required?: boolean;
  placeholder: string;
  children?: any;
}

let timeout: any = null;

export default forwardRef(
  (
    {
      dictionary,
      value,
      onChange,
      disabled,
      placeholder,
      required,
      children,
    }: SelectItemProps,
    ref: any
  ) => {
    const divRef = useRef<any>();
    const [text, setText] = useState<string>("");
    const [visible, setVisible] = useState<boolean>(false);
    const [pageSize, setPageSize] = useState(10);
    const [pageIndex, setPageIndex] = useState(0);
    const [finished, setFinished] = useState<boolean>(false);
    const [filter, setFilter] = useState<string>("");
    const [checkedOptions, setCheckedOptions] = useState<string>(
      value ? value : ""
    );
    const [options, setOptions] = useState<
      {
        name: string;
        uuid: string;
      }[]
    >([]);

    let dictionaryName = dictionary;
    let colName = "";
    if (dictionary.indexOf(".")) {
      dictionaryName = dictionary.split(".")[0];
      colName = dictionary.split(".")[1];
    }

    const getOptions = useCallback(
      async (filter, pageIndex) => {
        const resp = await axios.post<any>(
          `/crm/common/CommonApi/GetZLSelectDict?filter=${filter}&pageIndex=${pageIndex}&pageSize=${pageSize}&key=${""}&colName=${
            colName || ""
          }`,
          { dictionaryName: dictionaryName }
        );
        if (resp.data.Status === "1") {
          if (resp.data.Data.length < 10) {
            setFinished(true);
          }

          if (pageIndex === 0) {
            setOptions(resp.data.Data);
          } else {
            setOptions((prevState) => [...prevState, ...resp.data.Data]);
          }
        }
      },
      [colName, dictionaryName, pageSize]
    );

    useEffect(() => {
      if (value) {
        setCheckedOptions(value);
      }
    }, [value]);

    useEffect(() => {
      (async function () {
        getOptions("", 0);
      })();
    }, [getOptions]);

    useUpdateEffect(() => {
      if (pageIndex === 0) return;
      getOptions(filter, pageIndex);
    }, [filter, getOptions, pageIndex]);

    useUpdateEffect(() => {
      getOptions(filter, 0);
    }, [filter, getOptions]);

    useEffect(() => {
      (async () => {
        if (value === undefined) {
          setCheckedOptions("");
          setText("");
          return;
        }
        if (checkedOptions === undefined || checkedOptions === "") return;
        const resp = await axios.post<any>(
          `/crm/common/CommonApi/GetZLSelectDict?pageIndex=&pageSize=&key=&filter=setValue&colName=`,
          { dictionaryName: dictionaryName, selectId: checkedOptions }
        );
        setText(
          resp.data.Data.length > 0
            ? resp.data.Data.map((item: { name: any }) => item.name).join(",")
            : ""
        );
      })();
    }, [checkedOptions, dictionaryName, value]);

    const divScroll = useCallback(
      async (e) => {
        if (
          e.currentTarget.scrollHeight -
            e.currentTarget.offsetHeight -
            e.currentTarget.scrollTop ===
          0
        ) {
          if (finished) {
            return;
          }
          setPageIndex((prevState) => prevState + 1);
        }
      },
      [finished]
    );

    const style = useMemo((): CSSProperties => {
      return {
        height: 300,
        overflowY: "auto",
      };
    }, []);

    const RadioItemClick = useCallback(
      (e) => {
        setText(e.name);
        setCheckedOptions(e.uuid);
        onChange(e.uuid);
        setVisible(false);
      },
      [onChange]
    );

    const searchBarChange = useCallback((value) => {
      timeout && clearTimeout(timeout);
      timeout = setTimeout(() => {
        divRef.current.scrollTo(0, 0);
        setPageIndex(0);
        setFinished(false);
        setFilter(encodeURI("name like '%" + value + "%'"));
      }, 1000);
    }, []);

    return (
      <div style={{ display: "flex" }}>
        <div className="table-grid-item-title">
          {required && <span className="adm-form-item-label-required">*</span>}
          {children}
        </div>
        <InputItem
          value={text}
          placeholder={disabled ? "" : "请选择" + children.props.children}
          style={{ fontSize: 15, flex: 1, textAlign: "left" }}
          className="border-bottom-d9"
          editable={false}
          onClick={() => {
            !disabled && setVisible(true);
          }}>
          {/* {children} */}
        </InputItem>
        <RightOutline
          onClick={() => {
            !disabled && setVisible(true);
          }}
          className="arrow-right-button"
        />
        {/* 弹框部分 */}
        <Popup
          visible={visible}
          position="bottom"
          onMaskClick={() => {
            setVisible(false);
          }}>
          <SearchBar placeholder={placeholder} onChange={searchBarChange} />
          <div onScroll={divScroll} style={style} ref={divRef}>
            {options.map((e) => (
              <Radio.RadioItem
                key={e.uuid}
                checked={checkedOptions === e.uuid}
                onClick={RadioItemClick.bind(null, e)}>
                {e.name}
              </Radio.RadioItem>
            ))}
          </div>
        </Popup>
      </div>
    );
  }
);
